import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$('#header > a').wrap('<div class="companyLogo"></div>' );
$('.PHSearch').appendTo('.companyLogo');
$('.OpenMenu').hide();
$('#Common').addClass('menu');
$('.PHSearch').addClass('input-group input-group-rounded');
$('#quickSearchPV').addClass('input-group-field');
$('#btnQuickSearch').wrap('<div class="input-group-button"></div>');
$('#btnQuickSearch').addClass('button secondary');
$('#navigation > ul').addClass('MainMenu vertical menu accordion-menu');
$('#navigation > ul').attr('data-accordion-menu','');
$('#navigation ul.SubMenu').addClass('vertical menu nested is-active');
$('input[type=submit]').addClass('button secondary');
$('table.SortimentTable > thead > tr > th:nth-child(15)').addClass('text-center');
$('#PageBasket > a > img').attr('src','/assets/img/cart.png');
$('a.buy-button img').attr('src','/assets/img/cart.png');
$('#quickSearchPV ').attr('placeholder','Sök bland vårt sortiment');
$(document).foundation();